'use client';

import { useEffect, useState } from "react";
import { useRouter } from "next/navigation";
import Link from '@/components/LocaleLink';
import useLocalePath from '@/hooks/useLocalePath';
import dynamic from 'next/dynamic';
import { seo } from "@/utils/seo";

const CakeIcon = dynamic(() => import('@mui/icons-material/Cake'), { ssr: false });
const MailIcon = dynamic(() => import('@mui/icons-material/Mail'), { ssr: false });
const VisibilityIcon = dynamic(() => import('@mui/icons-material/Visibility'), { ssr: false });

import { FaChevronCircleRight } from "react-icons/fa";
import { removeFamilyMember, getFamilyMembers } from "@/utils/user_service";
import { useSessionContext } from "supertokens-auth-react/recipe/session";
import { useTranslation } from '@/contexts/TranslationContext';

const ViewMember = () => {
  const [familyMembersList, setFamilyMembersList] = useState();
  const router = useRouter();
  const localePath = useLocalePath();
  const session = useSessionContext();
  const { t } = useTranslation();

  const deleteMember = (e) => {
    if (window.confirm(t("members.confirmRemove"))) {
      let famMemberId = e.target.id;
      removeFamilyMember(famMemberId)
        .then((res) => {
          if (res.status === 200) {
            setFamilyMembersList(familyMembersList.filter((obj) => obj.id !== famMemberId));
            alert(t("members.removeSuccess"));
          } else if (res.status === 401 || res.status === 403) {
            window.localStorage.setItem("lm_previous_path", router.pathname);
            router.push(localePath("/signin"));
          } else alert(t("members.removeError"));
        })
        .catch((err) => console.log(err));
    }
  };

  useEffect(() => {
    seo(window.location.pathname);

    if (session.loading === false) {
      if (!session.doesSessionExist) {
        window.localStorage.setItem("lm_previous_path", router.pathname);
        router.push(localePath("/signin"));
      } else {
        getFamilyMembers()
          .then((res) => {
            if (res.status === 200) {
              return res.json();
            } else if (res.status === 401 || res.status === 403) {
              window.localStorage.setItem("lm_previous_path", router.pathname);
              router.push(localePath("/signin"));
            } else throw new Error(res.statusText);
          })
          .then((data) => {
            setFamilyMembersList(data);
          })
          .catch((err) => console.log(err));
      }
    }
  }, [session, router]);

  return (
    <div id="content" className="app-content" role="main">
      <div className="bg-light lter b-b wrapper-md">
        <h1 className="m-n font-thin h3">{t("members.heading")}</h1>
      </div>

      <div className="app-content-body">
        <div className="wrapper-md">
          <div className="row">
            <div className="col-3"></div>
            <div className="col-6">
              <div className="pull-right">
                <Link prefetch={false} href="/members/add" passHref>
                  <span className="btn btn-default">{t("members.addButton")}</span>
                </Link>
              </div>
            </div>
          </div>
          <br />
          <div className="row">
            <div className="col-3"></div>
            <div className="col-6" >
              {!familyMembersList && (
                <div>
                  <div className="b-a b-2x b-dashed wrapper-lg lter text-center">
                    {t("members.emptyState")}
                  </div>
                </div>
              )}
              {familyMembersList &&
                familyMembersList.map((el) => (
                  <div
                    body
                    key={el.id}
                    className="card panel panel-default p-0"
                    style={{ border: "1px solid black" }}
                  >
                    <div className="card-header panel-heading px-3 py-2">
                      <div className="clearfix">
                        <div className="clear">
                          <div className="h3 m-t-xs m-b-xs">
                            {el.name}
                            <span
                              className="pull-right"
                              id={el.id}
                              onClick={deleteMember}
                              style={{ fontFamily: "monospace", cursor: "pointer" }}
                            >
                              x
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="list-group no-radius alt">
                      <div className="list-group-item">
                        <CakeIcon className="text-muted me-2" />
                        {t("form.dateOfBirth")}
                        <span className="badge bg-success pull-right">
                          {el.dob ? new Date(el.dob).toDateString() : "N/A"}
                        </span>
                      </div>
                      <div className="list-group-item">
                        <MailIcon className="text-muted me-2" />
                        {t("members.sex")}
                        <span className="badge bg-info pull-right">
                          {el.gender === "m" ? t("familyMember.male") : t("familyMember.female")}
                        </span>
                      </div>
                      <Link prefetch={false} href={`/members/measurements/${el.id}`} passHref>
                        <div className="list-group-item">
                          <VisibilityIcon className="text-muted me-2" />
                          {t("members.measurementInfo")}
                          <FaChevronCircleRight className="text-muted pull-right" />
                        </div>
                      </Link>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewMember;
